var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverview3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 44,
    viewBox: "0 0 58 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75439 43.2337C8.92127 43.2337 11.5088 40.6217 11.5088 37.425V0H45.1086V37.425C45.1086 40.6217 42.521 43.2337 39.3542 43.2337",
    fill: "#00B074"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5998 37.4248V33.0195H0V37.4248C0 40.6215 2.58757 43.2334 5.75445 43.2334H39.3542C36.1873 43.2334 33.5998 40.6215 33.5998 37.4248Z",
    fill: "#0A5239"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8206 7.4458H17.5337V9.31705H21.8206V7.4458Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3114 7.4458H25.1418V9.31705H38.3114V7.4458Z",
    fill: "#F7C604"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8206 14.0732H17.5337V15.9445H21.8206V14.0732Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3114 14.0732H25.1418V15.9445H38.3114V14.0732Z",
    fill: "#F7C604"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8206 20.7007H17.5337V22.5719H21.8206V20.7007Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3114 20.7007H25.1418V22.5719H38.3114V20.7007Z",
    fill: "#F7C604"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8206 27.3281H17.5337V29.1994H21.8206V27.3281Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3114 27.3281H25.1418V29.1994H38.3114V27.3281Z",
    fill: "#F7C604"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M45.1086 27.64V5.37989C44.6451 5.30192 44.1431 5.26294 43.641 5.26294C37.5003 5.26294 32.5183 10.2919 32.5183 16.4904C32.5183 22.689 37.5003 27.7179 43.641 27.7179C44.1431 27.7569 44.6451 27.7179 45.1086 27.64Z",
    fill: "#0C1E5B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3761 24.5759C53.0245 24.5759 57.6034 19.9596 57.6034 14.265C57.6034 8.57045 53.0245 3.9541 47.3761 3.9541C41.7277 3.9541 37.1488 8.57045 37.1488 14.265C37.1488 19.9596 41.7277 24.5759 47.3761 24.5759Z",
    fill: "#FF5B5B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8526 17.4591C50.148 17.4583 50.4405 17.3994 50.7132 17.2857C50.9859 17.172 51.2335 17.0056 51.4419 16.7962C51.6504 16.5867 51.8155 16.3383 51.9279 16.065C52.0403 15.7918 52.0978 15.499 52.0971 15.2036C52.0963 14.9081 52.0374 14.6157 51.9237 14.3429C51.81 14.0702 51.6436 13.8226 51.4342 13.6142C51.2247 13.4058 50.9763 13.2406 50.703 13.1282C50.4298 13.0158 50.137 12.9583 49.8416 12.9591M49.8416 12.9591C49.8486 12.8767 49.8522 12.7934 49.8526 12.7091C49.8537 11.9997 49.5806 11.3173 49.0903 10.8045C48.6001 10.2917 47.9307 9.98822 47.2219 9.95743C46.5132 9.92664 45.82 10.1709 45.2871 10.6393C44.7543 11.1076 44.423 11.7637 44.3626 12.4706M49.8416 12.9591C49.8098 13.3078 49.7117 13.6472 49.5526 13.9591M44.3626 12.4706C43.7661 12.5276 43.21 12.797 42.7955 13.2297C42.381 13.6623 42.1357 14.2294 42.1042 14.8278C42.0727 15.4261 42.2571 16.0158 42.6239 16.4896C42.9907 16.9634 43.5154 17.2897 44.1026 17.4091M44.3626 12.4706C44.4416 12.4629 44.5216 12.4591 44.6026 12.4591C45.1656 12.4591 45.6851 12.6451 46.1026 12.9591M45.6026 17.9591C45.6026 17.9591 46.1026 17.9591 46.6026 18.9591C46.6026 18.9591 48.1911 16.4591 49.6026 15.9591",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview3);
export default __webpack_public_path__ + "static/media/overview-3.43450adfbacba161257dc6d846a049e1.svg";
export { ForwardRef as ReactComponent };